import {
  usePropsFor,
  VideoGallery,
  ControlBar,
  CameraButton,
  MicrophoneButton,
  EndCallButton,
  ParticipantList,
  ControlBarButton,
  ParticipantsButton,
} from "@azure/communication-react";
import {
  Stack,
  MessageBar,
  Panel,
  MessageBarType,
  Label,
} from "@fluentui/react";
import React, { useCallback, useState, useEffect } from "react";
import { People20Filled, Record20Filled } from "@fluentui/react-icons";
import { useId, useBoolean } from "@fluentui/react-hooks";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/Dialog";
import { PrimaryButton, DefaultButton } from "@fluentui/react/lib/Button";
import { mergeStyles } from "@fluentui/react/lib/Styling";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { ContextualMenu } from "@fluentui/react/lib/ContextualMenu";
import axios from "axios";
import { useGlobalState } from "../utils/GlobalState";
import { ExamDetails } from "../models/IExamDetails";
import { getDateFormatted, getFormattedDate } from "../utils/AppUtils";
import { RecordingService } from "../services/recording.service";
import { IStudentDetails } from "../models/StudentDetails";
import { useTimer, TimerRenderer } from "react-use-precision-timer";
import { useMsal } from "@azure/msal-react";

export interface CallScreenProps {
  onCallEnded: () => void;
  Details: ExamDetails;
  StudentDetails?: IStudentDetails;
}

const dialogStyles = { main: { maxWidth: 450 } };
const dragOptions = {
  moveMenuItemText: "Move",
  closeMenuItemText: "Close",
  menu: ContextualMenu,
  keepInBounds: true,
};
const dialogContentProps1 = {
  type: DialogType.normal,
  title: "Record ? ",
  closeButtonAriaLabel: "Close",
  subText: "Start Recording?",
};
const dialogContentProps2 = {
  type: DialogType.normal,
  title: "Record ? ",
  closeButtonAriaLabel: "Close",
  subText: "Stop recording and upload? ",
};

const dialogContentProps3 = {
  type: DialogType.normal,
  title: "Dismiss Student ? ",
  closeButtonAriaLabel: "Close",
  subText: "Are you sure you want to end this exam session ?",
};
const dialogContentProps4 = {
  type: DialogType.normal,
  title: "Dismiss Student ? ",
  closeButtonAriaLabel: "Close",
  subText:
    "Recording is in progress: are you sure you  want to end this exam session?",
};

const dialogContentProps5 = {
  type: DialogType.normal,
  title: "Leave Call ? ",
  closeButtonAriaLabel: "Close",
  subText: "Are you sure you want to leave this call? ",
};

const dialogContentProps6 = {
  type: DialogType.normal,
  title: "Leave Call ?",
  closeButtonAriaLabel: "Close",
  subText:
    "Recording is in progress: are you sure you want to leave this call? ",
};

const joinedDialogProps = {
  type: DialogType.normal,
  title: "Student Joined",
  subText: "Student has joined.",
};

const RecordBtn = mergeStyles({
  background: "red",
  color: "white",
});

function CallingComponents(props: CallScreenProps): JSX.Element {
  const { instance } = useMsal();
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);
  const [seconds, setSeconds] = useState<number>(0);
  const [minutes, setMinutes] = useState<number>(0);
  const [timerOn, setTimerOn] = useState<boolean>(false);
  const [recording, setRecording] = useState<boolean>(false);
  const [isRecordingLoading, setIsRecordingLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<boolean>(false);
  const videoGalleryProps = usePropsFor(VideoGallery);
  const cameraProps = usePropsFor(CameraButton);
  const microphoneProps = usePropsFor(MicrophoneButton);
  const endCallProps = usePropsFor(EndCallButton);
  const participantsProps = usePropsFor(ParticipantList);
  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const [dismissDialog, { toggle: toggleDismissDialog }] = useBoolean(true);
  const [endcallDialog, { toggle: toggleEndcallDialog }] = useBoolean(true);
  const [studentjoinedDialog, { toggle: toggleStudentJoinedDialog }] =
    useBoolean(true);
  const [isDraggable, { toggle: toggleIsDraggable }] = useBoolean(false);
  const labelId: string = useId("dialogLabel");
  const subTextId: string = useId("subTextLabel");
  const [callEnded, setCallEnded] = useState(false);
  const { state } = useGlobalState();
  const timer = useTimer();

  const modalProps = React.useMemo(
    () => ({
      titleAriaId: labelId,
      subtitleAriaId: subTextId,
      isBlocking: false,
      styles: dialogStyles,
      dragOptions: isDraggable ? dragOptions : undefined,
    }),
    [isDraggable, labelId, subTextId]
  );

  const controlBarStyle = {
    root: {
      justifyContent: "center",
    },
  };

  const onHangup = useCallback(async (): Promise<void> => {
    await endCallProps.onHangUp();
    setCallEnded(true);
  }, [endCallProps]);

  const recordingService = new RecordingService(instance);

  const [recordinID, setRecordingId] = useState("");

  const startRecording = async () => {
    setIsRecordingLoading(true);
    recordingService
      .startRecording(
        state.meetingId!,
        props.StudentDetails?.studentId!,
        props.Details.examId
      )
      .then((recordingId) => {
        setRecordingId(recordingId);
        setMinutes(0);
        setSeconds(0);
        setRecording(true);
        setTimerOn(true);
      })
      .finally(() => {
        setIsRecordingLoading(false);
      });
  };
  const stopRecording = async () => {
    recordingService
      .stopRecording(
        state.meetingId!,
        props.StudentDetails?.studentId!,
        props.Details.examinationId,
        recordinID,
        props.Details.attendentsId
      )
      .then((data) => {
        setRecording(false);
        setMessage(true);
        setTimerOn(false);
      });
  };

  if (callEnded) {
    props.onCallEnded();
  }
  const containerStyle = { height: "92vh" };

  useEffect(() => {
    // let timer: any = null;
    // if (timerOn) {
    //   timer = setInterval(() => {
    //     setSeconds(Number(seconds) + 1);
    //     if (seconds === 59) {
    //       setMinutes(Number(minutes) + 1);
    //       setSeconds(0);
    //     }
    //   }, 1000);
    // } else {
    //   clearInterval(timer);
    // }
    // return () => clearInterval(timer);

    ////////////////////////////////// NEW IMPLEMENTATION FOR TIMER
    if (timerOn) {
      console.log("[INFO] Timer started.");
      timer.start();
      console.log(
        `[INFO] Get timer started time (in millisecond) ${timer.getStartTime()}`
      );
    } else {
      console.log("[INFO] Timer stopped");
      timer.stop();
      console.log(
        `[INFO] Get timer stopped time (in millisecond) ${Date.now()}`
      );
    }
  }, [timerOn, timer]);

  const customOnRenderText = (): JSX.Element => {
    return (
      <Label
        key={"participantsCustomLabelKey"}
        style={{ fontSize: "0.625rem", fontWeight: 400 }}
      >
        Participant
      </Label>
    );
  };

  const mouseClickEvents = ["click"];
  const simulateMouseClick = (element: any) => {
    mouseClickEvents.forEach((mouseEventType) =>
      element.dispatchEvent(
        new MouseEvent(mouseEventType, {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        })
      )
    );
  };

  const [view, setView] = useState(false);
  videoGalleryProps.onCreateLocalStreamView().then(() => {
    if (!view) {
      setView(true);
      setTimeout(() => {
        var camera = document.querySelector("button[id='CameraButton']");
        simulateMouseClick(camera);
        var microphone = document.querySelector(
          "button[id='MicrophoneButton']"
        );
        simulateMouseClick(microphone);
      }, 5000);
    }
  });

  return (
    <>
      <Stack style={containerStyle}>
        {recording && timerOn && (
          <div style={{ position: "absolute", top: -10, zIndex: 5, right: 10 }}>
            {/* <h2>
              {minutes < 10 ? "0" + minutes : minutes} :{" "}
              {seconds < 10 ? "0" + seconds : seconds}
            </h2> */}

            <TimerRenderer
              timer={timer}
              render={(timer) => {
                //const dateObject = new Date(timer.getElapsedRunningTime());
                const milliseconds = timer.getElapsedRunningTime();
                const second = Math.floor((milliseconds / 1000) % 60).toFixed(
                  0
                );
                const minute = Math.floor(
                  (milliseconds / (1000 * 60)) % 60
                ).toFixed(0);
                const hour = Math.floor(
                  (milliseconds / (1000 * 60 * 60)) % 24
                ).toFixed(0);

                return (
                  <h2>{`${String(hour).padStart(2, "0")} : ${String(
                    minute
                  ).padStart(2, "0")} : ${String(second).padStart(
                    2,
                    "0"
                  )}`}</h2>
                );
              }}
            />
          </div>
        )}
        {recording && (
          <div
            style={{
              zIndex: 1,
              position: "absolute",
              top: 3,
              left: 0,
              right: 0,
            }}
          >
            <MessageBar
              style={{
                fontSize: 16,
                fontWeight: 600,
              }}
              messageBarType={MessageBarType.warning}
              isMultiline={false}
              dismissButtonAriaLabel="Close"
            >
              Recording has started !
            </MessageBar>
          </div>
        )}

        {message && !recording && (
          <div
            style={{
              zIndex: 1,
              position: "absolute",
              top: 3,
              left: 0,
              right: 0,
            }}
          >
            <MessageBar
              style={{
                fontSize: 16,
                fontWeight: 600,
              }}
              messageBarType={MessageBarType.warning}
              isMultiline={false}
              dismissButtonAriaLabel="Close"
            >
              Recording has ended and saved !
            </MessageBar>
          </div>
        )}
        <div
          style={{
            height: "540rem",
            width: "100%",
            border: "1px solid",
            position: "relative",
          }}
        >
          {/* <VideoGallery
            layout='floatingLocalVideo'
            localParticipant={MockLocalParticipant}
            remoteParticipants={MockRemoteParticipants}
          /> */}

          {videoGalleryProps && (
            <VideoGallery
              layout="floatingLocalVideo"
              {...videoGalleryProps}
              key={"VideoGallery"}
            />
          )}
        </div>

        <ControlBar layout="dockedBottom" styles={controlBarStyle}>
          {cameraProps && (
            <CameraButton
              id={"CameraButton"}
              key={"CameraButton"}
              showLabel={true}
              {...cameraProps}
            />
          )}
          {microphoneProps && (
            <MicrophoneButton
              id={"MicrophoneButton"}
              key={"MicrophoneButton"}
              showLabel={true}
              {...microphoneProps}
            />
          )}
          {participantsProps && (
            <ParticipantsButton
              showLabel={true}
              {...participantsProps}
              onRenderText={customOnRenderText}
              disabled={recording}
            />
          )}
          <ControlBarButton
            key={"recordIcon"}
            onRenderIcon={() =>
              isRecordingLoading ? (
                <Spinner size={SpinnerSize.small} />
              ) : (
                <Record20Filled key={"recordIconKey"} />
              )
            }
            strings={{ label: isRecordingLoading ? "Loading..." : recording ? "Stop Recording" : "Record" }}
            labelKey="Record"
            showLabel={true}
            className={recording ? RecordBtn : ""}
            onClick={() => {
              toggleHideDialog();
            }}
            tooltipId="Recording"
            disabled={isRecordingLoading}
          />
          {participantsProps && (
            <ControlBarButton
              key={"peopleIcon"}
              onRenderIcon={() => (
                <People20Filled
                  key={"peopleIconKey"}
                // primaryFill="currentColor"
                />
              )}
              strings={{ label: "Student details" }}
              labelKey={"peopleButtonLabel"}
              showLabel={true}
              onClick={() => {
                openPanel();
              }}
            />
          )}

          {/* <ControlBarButton
            key={"callProhibitedIcon"}
            onRenderIcon={() => (
              <CallProhibited20Filled
                key={"callProhibitedIconKey"}
                primaryFill="currentColor"
              />
            )}
            strings={{ label: "Dismiss" }}
            labelKey={"callProhibiteButtonLabel"}
            showLabel={true}
            onClick={() => {
              toggleDismissDialog();
            }}
          /> */}

          {endCallProps && (
            <EndCallButton
              key={"EndCallButton"}
              showLabel={true}
              onClick={() => toggleEndcallDialog()}
            />
          )}
        </ControlBar>

        {/* dialog for stop and start recording */}
        <Dialog
          key={"Dialog"}
          hidden={hideDialog}
          onDismiss={toggleHideDialog}
          dialogContentProps={
            !recording ? dialogContentProps1 : dialogContentProps2
          }
          modalProps={modalProps}
        >
          <DialogFooter>
            <DefaultButton
              onClick={() => {
                if (!recording) {
                  // start recording api call
                  startRecording();
                } else {
                  // stop recording api call
                  stopRecording();
                }
                toggleHideDialog();
              }}
              text="Yes"
            />
            <PrimaryButton
              key={"PrimaryButton"}
              onClick={toggleHideDialog}
              text="No"
            />
          </DialogFooter>
        </Dialog>

        {/* dialog to dismiss  */}
        <Dialog
          hidden={dismissDialog}
          onDismiss={toggleDismissDialog}
          dialogContentProps={
            !recording ? dialogContentProps3 : dialogContentProps4
          }
          modalProps={modalProps}
        >
          <DialogFooter>
            <DefaultButton
              onClick={() => {
                if (recording) {
                  setRecording(false);
                  setMessage(true);
                  stopRecording();
                  setTimerOn(false);
                }
                //dismiss student function call here..
                console.log("Dismissed Student !");
                toggleDismissDialog();
              }}
              text="Yes"
            />
            <PrimaryButton onClick={toggleDismissDialog} text="No" />
          </DialogFooter>
        </Dialog>

        {/* dialog to end call */}
        <Dialog
          hidden={endcallDialog}
          onDismiss={toggleEndcallDialog}
          dialogContentProps={
            !recording ? dialogContentProps5 : dialogContentProps6
          }
          modalProps={modalProps}
        >
          <DialogFooter>
            <DefaultButton
              onClick={() => {
                if (recording) {
                  setRecording(false);
                  setMessage(true);
                  stopRecording();
                  setTimerOn(false);
                }
                onHangup();
                //end call function call here..
                toggleEndcallDialog();
              }}
              text="Yes"
            />
            <PrimaryButton onClick={toggleEndcallDialog} text="No" />
          </DialogFooter>
        </Dialog>

        <Dialog
          hidden={studentjoinedDialog}
          onDismiss={toggleStudentJoinedDialog}
          dialogContentProps={joinedDialogProps}
          modalProps={modalProps}
        >
          <div style={{ textAlign: "right" }}>
            <PrimaryButton
              onClick={() => {
                toggleStudentJoinedDialog();
              }}
              text="Ok"
            />
          </div>
        </Dialog>

        <Panel
          headerText="Student Details"
          isOpen={isOpen}
          onDismiss={dismissPanel}
          closeButtonAriaLabel="Close"
        >
          <h3>Exam Name : {props.Details.examName}</h3>
          <h3>Student Number : {props.StudentDetails?.studentId}</h3>
          <h3>
            Date Of Birth: {props.StudentDetails?.dob.toString().split("T")[0]}
          </h3>
        </Panel>
      </Stack>
    </>
  );
}

function CallEnded(): JSX.Element {
  return <h1>You ended the call.</h1>;
}

export default CallingComponents;
